import { Container, Grid } from "@eworkit/iris";
import React, { FC, useContext } from "react";

import { UserContext } from "@/components/User";

import { DashboardOpenJobsButton } from "./components";
//import { DashboardInfoBox } from "./components/DashboardInfoBox";
import { useDashboardStats } from "./hooks";
import {
  DashboardJobsSection,
  DashboardProfileSection,
  DashboardRecentlyViewedSection,
  DashboardStatsSection,
  DashboardTasksSection,
} from "./sections";

export enum DashboardType {
  COMPANY,
  PRIVATE,
}

export const DashboardPage: FC = () => {
  const { contextConsultantProfile, contextCompany, hasCompanyManagerPrivileges } = useContext(UserContext);

  const { stats, openJobs, recommendedJobs, savedJobs } = useDashboardStats();

  return (
    <Container>
      {/* 
        <Grid>
          <DashboardInfoBox />
        </Grid> 
       */}
      <Grid
        columns="repeat(4, 1fr)"
        sx={{ py: ["sm", null, null, "xxl"], px: ["xs", null, "sm", null] }}
        gap={["xs", null, null, "sm"]}>
        <DashboardStatsSection items={stats} />
        <DashboardOpenJobsButton count={openJobs} />
        <DashboardProfileSection />
        {contextCompany && hasCompanyManagerPrivileges() ? (
          <DashboardTasksSection name={contextConsultantProfile?.firstName} companyId={contextCompany?.id} />
        ) : (
          <DashboardRecentlyViewedSection />
        )}
        <DashboardJobsSection recommendedJobsCount={recommendedJobs} savedJobsCount={savedJobs} />
      </Grid>
    </Container>
  );
};
